import React from 'react';
import ReactDOM from 'react-dom';
import App, { AppProps } from './App';
import { decode } from '@finn-no/safe-props';

const app = document.getElementById('organisation-contact');
if (app) {
    const props = decode<AppProps>(app.dataset.props || '');
    ReactDOM.hydrate(<App {...props} />, app);
}
